import type { Role } from "../types";

// Only a language picked with the switcher is remembered. Until then teachers
// get Urdu and everyone else English, decided again whenever someone logs in.
const CHOICE_KEY = "language-choice";

export function rememberLanguage(language: string): void {
  localStorage.setItem(CHOICE_KEY, language);
}

export function defaultLanguage(role: Role | null): string {
  return localStorage.getItem(CHOICE_KEY) || (role === "teacher" ? "ur" : "en");
}

// Teachers start every sign-in in Urdu, whatever was picked last time.
export function forgetLanguageChoice(): void {
  localStorage.removeItem(CHOICE_KEY);
}
